<template>
  <section>
    <div
      class="video"
      :style="{
        'background-image': `url('${$baseUrl}images/${content.videoCover}.webp')`,
      }"
      @click="
        changeModal({
          event: content.event,
          eventDetail: content.eventDetail,
          contentTitle: content.title,
          contentUrl: content.source,
          ctaLabel: content.icon,
        })
      "
    >
      <p class="video__title">{{ content.title }}</p>
      <button class="video__button" :aria-label="$t('general.cta.openVideo')">
        <icon
          :data="pageIcons[content.icon]"
          class="video__button__icon"
        ></icon>
      </button>
    </div>
    <Transition name="slide-in">
      <VideoModal
        v-if="modalOpen"
        @changeModal="changeModal"
        :videoSource="content.source"
        :poster="content.poster"
        :icon="content.closeIcon"
      />
    </Transition>
  </section>
</template>

<script setup>
import { ref } from "vue";
import { pageIcons } from "../../../plugins/page-icons";
import { useGoogleAnalytics } from "../../../plugins/useGoogleAnalitycs";
import VideoModal from "./VideoModal.vue";

const { digitalData } = useGoogleAnalytics();
const modalOpen = ref(false);

const changeModal = (object) => {
  if (object) digitalData(object);
  modalOpen.value = !modalOpen.value;
};

defineProps({
  content: Object,
});
</script>

<style lang="scss" scoped>
.video {
  --width: 100%;

  height: 52vh;
  background-repeat: no-repeat;
  background-size: 102%;
  background-position: 50% 60%;
  position: relative;
  @include video-shadow;
  transition: box-shadow 0.3s ease, background-size 0.5s ease;
  cursor: pointer;

  &:hover {
    @include shadow-year-highlight;
    background-size: 107%;
    .video__button__icon {
      fill: $primary-yellow;
    }
  }

  &__title {
    position: absolute;
    top: calc(var(--width) / 3);
    left: 50%;
    transform: translate(-50%, 0);
    color: $scala-grigi-white;
    @include title-h-3;
  }

  &__button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: $scala-grigi-white;
    border-radius: 100%;
    padding: toRem(10);

    &__icon {
      min-height: 2rem;
      min-width: 2rem;
      transition: fill 0.3s ease;
    }
  }
}

.tablet,
.mobile {
  .video {
    width: 65%;
    height: 65vh;
    margin: 0 auto;
    background-size: cover;
    background-position: center center;

    &__title {
      top: calc(50% - toRem(70) - toRem(19));
      @include title-h-4;
    }

    &__button {
      padding: toRem(14);

      &__icon {
        min-height: 2.625rem;
        min-width: 2.625rem;
      }
    }
  }
}

.mobile {
  .video {
    width: 90%;

    &__title {
      white-space: nowrap;
      top: calc(50% - toRem(70) - toRem(13));
    }

    &__button {
      padding: toRem(10);
      &__icon {
        min-height: 2rem;
        min-width: 2rem;
      }
    }
  }
}
</style>
